import SearchInstallationInput from './SearchInstallationInput';

export default SearchInstallationInput;
